<div class="selecao-propriedades">
  <div class="alert alert-danger" role="alert" ng-if="contratoMensagens.length && daysToBlockContract > 0">
    Prezado cliente, existem divergências em seu contrato, por favor, entre em contato com a Agro1
    <span ng-if="daysToBlockContract > 1">
      em até {{daysToBlockContract}} dias,
    </span>
    para evitar o bloqueio temporário do sistema.
    <ul>
      <li ng-repeat="mensagem in contratoMensagens">{{mensagem}}</li>
    </ul>
    <a href="/#!/parametro#contrato">Mais informações</a>
  </div>

  <div class="alert alert-danger" ng-if="daysRemainingContract <= 30">
    <p>Prezado cliente, seu contrato
      <span ng-if="daysRemainingContract > 1">
        irá vencer em {{daysRemainingContract}} dias,
      </span>
      <span ng-if="daysRemainingContract == 1">
        irá vencer AMANHÃ,
      </span>
      <span ng-if="daysRemainingContract == 0">
        vence HOJE,
      </span>
      <span ng-if="daysRemainingContract < 0">
        venceu há {{-daysRemainingContract}} 
          <ng-pluralize count="{{-daysRemainingContract}}" when="{
            '1': 'dia ',
            'other': 'dias '
          }">
          </ng-pluralize>
      </span>
      por gentileza, entre em contato para ajustar a renovação, antes do bloqueio temporário do sistema.
    </p>
    <a href="/#!/parametro#contrato">Mais informações</a>
  </div>

  <div class="flash-message-container">
    <br>
    <flash-message></flash-message>
  </div>

  <div class="row search-bar">
    <div class="col-xs-12 col-md-6 col-lg-8 col-md-push-6 col-lg-push-4 text-right">
      <button class="btn btn-info" ng-if="$root.permissions.parametro.canRead" ng-click="openUsageStatistics()">
        Estatísticas de uso
      </button>
    </div>
    <div class="col-xs-12 col-md-6 col-lg-4 col-md-pull-6 col-lg-pull-8">
      <div class="input-group">
        <span class="input-group-addon">
          <i class="fa fa-search text-cinza" aria-hidden="true"></i>
        </span>
        <input type="text"
          class="form-control"
          placeholder="Pesquisar" ng-model="filter.term"
          autofocus
          ng-change="reloadMaps()">
        <div class="input-group-btn" uib-dropdown>
          <button type="button" class="btn btn-white" uib-dropdown-toggle>
            <i class="fa" ng-class="{
              'fa-sort-numeric-asc': filter.order.field === '-update',
              'fa-sort-alpha-asc': filter.order.field === 'descricao'
            }"></i>
            {{ filter.order.descricao || 'Ordenar'}}
            <span class="caret"></span>
          </button>
          <ul class="dropdown-menu" uib-dropdown-menu role="menu">
            <li role="menuitem">
              <a href="#" ng-click="setOrder($event, 'descricao')">
                <i class="fa fa-sort-alpha-asc"></i>
                Alfabética
              </a>
            </li>
            <li role="menuitem">
              <a href="#" ng-click="setOrder($event, '-update')">
                <i class="fa fa-sort-numeric-asc"></i>
                Atualização
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>

  <div class="row">
    <div ng-repeat="propriedade in propriedades | orderBy:filter.order.field" ng-show="isShowPropriedade(propriedade.descricao, filter.term)">
      <div class="clearfix visible-lg-block" ng-if="$index % 3 == 0"></div>
      <div class="clearfix visible-md-block" ng-if="$index % 2 == 0"></div>

      <div class="col-xs-12 col-md-6 col-lg-4">
        <div class="panel panel-default-agro1">
          <div class="panel-heading" uib-dropdown is-open="propriedade.isShowNotificacoes">
            <h3 class="panel-title pull-left pointer" ng-click="setPropriedade(propriedade.id, $event)">
              <strong>{{ ::propriedade.descricao }}</strong> ({{::propriedade.area_total | number:2}} ha)
            </h3>

            <a class="count-info" uib-dropdown-toggle aria-expanded="true" ng-class="{active: propriedade.isShowNotificacoes}" ng-click="getHistoricos(historicos[propriedade.id])">
              <i class="fa fa-bell-o" aria-hidden="true"></i>
              <span ng-show="historicos[propriedade.id].nao_lidas && animated" class="label label-danger animated bounceIn">
                {{ ::historicos[propriedade.id].nao_lidas }}
              </span>
            </a>
            <span class="dropup" ng-show="propriedade.isShowNotificacoes">
              <span class="caret"></span>
            </span>

            <!-- Históricos -->
            <ul class="dropdown-menu dropdown-alerts no-padding pull-right" data-max-heigth>
              <li class="text-center loader-notificacoes" ng-show="historicos[propriedade.id].loading">
                <i class="fa fa-spinner fa-pulse fa-fw text-cinza"></i>
              </li>
              <li ng-if="!historicos[propriedade.id].loading">
                <span ng-if="!historicos[propriedade.id].historicos.length" class="text-muted">Nenhum registro</span>
                <table class="table no-margin" ng-if="historicos[propriedade.id].historicos.length">
                  <tbody>
                    <tr ng-repeat="historico in ::historicos[propriedade.id].historicos track by historico.id" ng-class="{info: !historico.lida}">
                      <td class="text-black">
                        {{ ::historico.gleba.descricao }}
                      </td>
                      <td class="text-right">
                        <span class="pointer" ng-click="goToPropriedadeWithHistorico(propriedade.id, historico)" historico="historico" agro-label-historico uib-tooltip="{{ historico.hint }}" tooltip-placement="left" tooltip-append-to-body="true">
                          <i class="text-white" agro-icon-historico historico="historico"></i>&nbsp;
                        </span>
                      </td>
                      <td class="text-muted small text-cinza">{{ ::historico.tempo_decorrido }}</td>
                    </tr>
                  </tbody>
                </table>
              </li>
            </ul>

            <div class="clearfix"></div>
          </div>

          <div class="panel-body no-padding pointer" ng-click="setPropriedade(propriedade.id, $event)" ng-if="propriedades.length < maxPropriedadesMaps">
            <div id="map_{{ propriedade.id }}" class="map"></div>
          </div>

          <div class="panel-footer text-cinza">
            <i class="fa fa-map-marker" aria-hidden="true"></i> {{::propriedade.cidade.nome}} - {{::propriedade.cidade.uf}}
            <div class="pull-right" ng-if="historicos[propriedade.id].atualizado">
              <i class="fa fa-refresh" aria-hidden="true"></i> <span ng-bind="historicos[propriedade.id].atualizado"></span>
            </div>
            <div class="arrow-panel" ng-if="!propriedade.loadingDetails">
              <i class="glyphicon pointer" ng-click="showDetails(propriedade)"
                ng-class="{'glyphicon-chevron-up': propriedade.details, 'glyphicon-chevron-down': !propriedade.details}"></i>
            </div>
          </div>

          <div class="list-group resumo-glebas" ng-show="propriedade.details || propriedade.loadingDetails">
            <p ng-show="propriedade.loadingDetails" class="text-center text-cinza loader-resumo">
              <i class="fa fa-spinner fa-pulse fa-fw"></i>
            </p>
            <a class="list-group-item" ng-repeat="alerta in propriedade.alerts | orderBy:'dias_desde_a_ultima_acao'" ng-click="goToPropriedadeWithAlerta(propriedade.id, alerta)">
              <div class="icons pull-right">
                <span ng-repeat="icone in alerta.images" class="bg-{{icone.status}} alert-icon alert-icon-margin">
                  <i agro-icon-historico historico="{tipo: icone.type}" uib-tooltip-template="'tooltip-hint-alerta.html'" tooltip-placement="left"></i>
                </span>
              </div>

              {{ alerta.descricao }} ({{ alerta.area_total | number:0 }} ha)<br>
              <small class="painel-alertas">
                <i class="icon-visit" aria-hidden="true"></i>&nbsp;
                <span ng-show="alerta.dias_desde_a_ultima_acao != null"> há {{ alerta.dias_desde_a_ultima_acao }} dias</span>
                <span ng-show="alerta.dias_desde_a_ultima_acao == null">sem visitas</span>
              </small>
              <small>
                <i class="icon-pulverization-fill" aria-hidden="true"></i>&nbsp;
                <span ng-show="alerta.ultima_pulverizacao != null"> há {{ alerta.ultima_pulverizacao }} dias</span>
                <span ng-show="alerta.ultima_pulverizacao == null">não pulverizado</span>
              </small>
              <br>
              <small ng-repeat="estadio in alerta.estadios">
                <span class="painel-alertas">
                  <i class="icon-plant" aria-hidden="true"></i>&nbsp;
                  <span ng-init="plantio = {dataPlantio: {inicio: estadio.plantio.inicio, fim: estadio.plantio.fim}}"
                        uib-tooltip-template="'tooltip-data-plantio.html'" tooltip-placement="right" tooltip-append-to-body="true">
                    {{estadio.atividade.descricao |lowercase}}
                  </span>
                </span>
                <i class="icon-stadium" aria-hidden="true"></i>&nbsp;
                <span>{{estadio.estadio.abreviatura}}</span>
                <br ng-show="$index < (alerta.estadios.length-1)">
              </small>
            </a>

            <div class="list-group-item" ng-if="!propriedade.loadingDetails"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<script type="text/ng-template" id="tooltip-data-plantio.html">
  <div>
    Plantio:
    <ng-include src="'views/directives/data_plantio_template.html'"></ng-include>
  </div>
</script>

<script type="text/ng-template" id="tooltip-hint-alerta.html">
  <div class="text-center">
    {{icone.description}}
    <ul ng-if="icone.hint" class="list-unstyled text-left">
      <li>&nbsp;</li>
      <li ng-repeat="hint in icone.hint">
        <small>{{hint}}</small>
      </li>
    </ul>
  </div>
</script>

<script type="text/ng-template" id="modal-usage-statistics.html">
  <div class="modal-header">
    <button type="button" class="close" ng-click="$close()">&times;</button>
    <h3 class="modal-title">Estatísticas de uso dos últimos 90 dias</h3>
  </div>
  <div class="modal-body">
    <usage-statistics></usage-statistics>
  </div>
</script>
